import { Box, Flex, spacing, StyleProps } from 'deepstash-ui';
import React from 'react';
import HashtagChipCarousel from 'src/components/hashtag/HashtagChipCarousel';
import { ChipData } from 'types';
import { SQUARE_WIDTH } from 'utils/global';
import commonStrings from 'utils/strings/commonStrings';
import SubsectionHeader from '../components/SubsectionHeader';

interface RelatedTopicsSectionProps {
  hashtags: ChipData[];
  rightHeaderElement?: React.ReactElement;
}

const RelatedTopicsSection: React.FC<
  RelatedTopicsSectionProps & StyleProps
> = ({ hashtags, rightHeaderElement, ...props }) => {
  return (
    <Box {...props}>
      <Flex justifyContent="space-between">
        <SubsectionHeader height={spacing.toRem(SQUARE_WIDTH - 4)}>
          {commonStrings.metacontent.relatedTopicsSectionHeader}
        </SubsectionHeader>
        {rightHeaderElement}
      </Flex>
      <HashtagChipCarousel hashtags={hashtags} pt={spacing.toRem(4)} />
    </Box>
  );
};

export default RelatedTopicsSection;
